// volto.ts — la spiegazione dell'analisi del volto da accettare prima della prima partita (scelte legali 5 e 6, v021).
// Se il testo della schermata cambia in modo che conta, si alza VERSIONE_VOLTO: la schermata ricompare a tutti con
// «Abbiamo aggiornato questa spiegazione» (volto.aggiornato). La versione accettata resta sul telefono e, con l'account,
// sul server (utenti.volto_versione).

export const VERSIONE_VOLTO = 1;

export function eVersioneVolto(n: unknown): n is number {
  return typeof n === "number" && Number.isInteger(n) && n >= 1 && n <= 999;
}
